export default __webpack_public_path__ + "static/media/pet-success-icon.4eb599d2.svg";